import { render, staticRenderFns } from "./socreList.vue?vue&type=template&id=131ae517&scoped=true"
import script from "./socreList.vue?vue&type=script&lang=js"
export * from "./socreList.vue?vue&type=script&lang=js"
import style0 from "./socreList.vue?vue&type=style&index=0&id=131ae517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ae517",
  null
  
)

export default component.exports